import {createSlice} from '@reduxjs/toolkit'
// import {encode} from 'base-64';
import {
    RJSC_SERVICE_URL, 
    // RJSC_USERNAME, 
    // RJSC_PWD,
    REQUEST_STATUS,
    APPLICATION_MODE_NEW
} from '../../app/constants'
import loadInitialStateObject from './initialStateUtil'
import {dummyRjscSearchResponse} from '../../app/utils.js'
import { setCompanyRjscDetails } from './rjscDetailReviewSlice'
import { saveBusinessLicenceApplicationData } from './businessLicenceApplicationSlice.js'

const SHOW_DUMMY_RESPONSE = false //(window.location.hostname === "localhost") 

const rjscSearchSlice = createSlice({
    name: 'rjscSearch',
    initialState : loadInitialStateObject('rjscSearch'),
    reducers : {
        setRjscSearchStringType(state, action) {
            const {searchType} = action.payload
            state.searchType = searchType
        },
        setRjscSearchString(state, action) {
            const {searchText} = action.payload
            state.searchText = searchText
        },
        setRjscSearchStatus(state, action) {
            state.searchStatus = action.payload
        },
        setRjscSearchStart(state, action) {
            state.searchStatus = REQUEST_STATUS.IN_PROGRESS
            state.searchResponseData = []
            state.error = ""
        },
        setRjscAdvanceSearchString(state, action) {
            const {searchText} = action.payload
            state.advanceSearchText = searchText
        },
        setRjscAdvanceSearchStart(state,action) { 
            state.searchStatus = REQUEST_STATUS.IN_PROGRESS
            state.advanceSearchResponseData = []
            state.error = ""
        },
        setRjscAdvanceSearchResponse(state, action) { 
            state.searchStatus = REQUEST_STATUS.SUCCESS
            state.advanceSearchResponseData = action.payload
        },
        setRjscSearchResponse(state, action) {
            // validate the data received
            let isValid = true
            // if(Array.isArray(action.payload) 
            //     && action.payload.length > 0)
            // {
            //     for (const res of action.payload) {
            //         if(!res.businessEntity) {
            //             isValid = false
            //             break
            //         }
            //     }    
            // }

            if(isValid) {
                state.searchStatus = REQUEST_STATUS.SUCCESS
                state.searchResponseData = action.payload
            } else { 
                state.searchStatus = REQUEST_STATUS.ERROR
                state.error = "Data not available"
            }
        },
        setRjscSearchError(state, action) {
            state.error = "search failed"
        },
        setDefaultRegistryNumber(state, action) { 
            // this is handled in rjscSearchResultSlice.js
        }
    }
})

export const { 
    setRjscSearchStringType,
    setRjscSearchString, 
    setRjscSearchStart,
    setRjscAdvanceSearchString,
    setRjscAdvanceSearchStart,
    setRjscAdvanceSearchResponse,
    setRjscSearchResponse,
    setRjscSearchError,
    setDefaultRegistryNumber,
    setRjscSearchStatus
} = rjscSearchSlice.actions

export const fetchRjscFromNumberAndUpdateApp =
    (rjscNumber, applicationType) => async (dispatch) => {
        try {
            dispatch(setRjscSearchStatus(REQUEST_STATUS.IN_PROGRESS));
            let fetchUrl = RJSC_SERVICE_URL;
            if (window.location.hostname === "localhost") {
                fetchUrl = `${RJSC_SERVICE_URL}Search`;
            }

            const resp = await fetch(`${fetchUrl}/${rjscNumber}`, {
                method: "GET"
            });
            const companyRjscData = await resp.json();
            const responseForNumber = companyRjscData?.businessEntity?.registryNumber
                ? parseInt(companyRjscData?.businessEntity?.registryNumber)
                : 0;
            if (responseForNumber && responseForNumber === parseInt(rjscNumber)) {
                if (companyRjscData?.businessData?.relatedTo) {
                    const ownerResp = await fetch(`${fetchUrl}/${companyRjscData.businessData.relatedTo}`, {
                        method: "GET"
                    });
                    const ownerRjscData = await ownerResp.json();

                    if (ownerRjscData?.businessData?.peopleList?.length) {
                        companyRjscData.businessData = Object.assign({}, companyRjscData.businessData, {
                            peopleList: ownerRjscData.businessData.peopleList
                        });
                    }

                    // It is found that only homeJurisdiction address is missing
                    // from the child rjsc data but it can be present in the
                    // owner rjsc. So check it and copy it from owner rjsc.
                    if (
                        !companyRjscData.businessContact.homeJurisdictionAddress &&
                        ownerRjscData?.businessContact?.homeJurisdictionAddress
                    ) {
                        companyRjscData.businessContact.homeJurisdictionAddress = {
                            ...ownerRjscData.businessContact.homeJurisdictionAddress
                        };
                    }
                }

                dispatch(setCompanyRjscDetails(companyRjscData));
                dispatch(
                    saveBusinessLicenceApplicationData(
                        applicationType,
                        APPLICATION_MODE_NEW,
                        false,
                        "UPDATE"
                    )
                ).then((data) => {
                        // save successful
                        dispatch(setRjscSearchStatus(REQUEST_STATUS.DATA_RECEIVED));
                    })
                    .catch((err) => {
                        // save error
                        dispatch(setRjscSearchStatus(REQUEST_STATUS.ERROR));
                    });
            } else {
                dispatch(setRjscSearchStatus(REQUEST_STATUS.ERROR));
                console.warn("error in RJSC search for number : " + rjscNumber);
            }
        } catch (e) {
            console.log("Catch error", e)
            dispatch(setRjscSearchStatus(REQUEST_STATUS.ERROR));
            return dispatch(setRjscSearchError("search failed"));
        }
};



export const fetchRjscFromNumberAndSetDetails = (rjscNumber) => async (dispatch) => {
    
    dispatch(setRjscSearchStatus(REQUEST_STATUS.IN_PROGRESS))
    
    try {
        let fetchUrl = RJSC_SERVICE_URL

        if(window.location.hostname === "localhost") {
            fetchUrl = `${RJSC_SERVICE_URL}Search`
        }

        const resp = await fetch(`${fetchUrl}/${rjscNumber}`, {
            method: "GET"
        })

        const companyRjscData = await resp.json()
        const responseForNumber = companyRjscData?.businessEntity?.registryNumber ? parseInt(companyRjscData?.businessEntity?.registryNumber) : 0;

        if (responseForNumber === parseInt(rjscNumber)) {
            if(companyRjscData?.businessData?.relatedTo) { 
                const ownerResp = await fetch(`${fetchUrl}/${companyRjscData.businessData.relatedTo}`, {
                    method: "GET"
                })
                const ownerRjscData = await ownerResp.json();

                if(ownerRjscData?.businessData?.peopleList?.length) { 
                    companyRjscData.businessData = Object.assign({},
                                    companyRjscData.businessData,
                                    {peopleList : ownerRjscData.businessData.peopleList} 
                                )
                }

                // It is found that only homeJurisdiction address is missing
                // from the child rjsc data but it can be present in the 
                // owner rjsc. So check it and copy it from owner rjsc.
                if(!companyRjscData.businessContact.homeJurisdictionAddress 
                    && ownerRjscData?.businessContact?.homeJurisdictionAddress) {
                    companyRjscData.businessContact.homeJurisdictionAddress = {
                        ...ownerRjscData.businessContact.homeJurisdictionAddress
                    }
                }
            }
            dispatch(setRjscSearchStatus(REQUEST_STATUS.DATA_RECEIVED))
            dispatch(setCompanyRjscDetails(companyRjscData))
        } else {
            dispatch(setRjscSearchStatus(REQUEST_STATUS.ERROR))    
            console.warn("error in RJSC search for number : " + rjscNumber)
        }
    } catch (error) {
        dispatch(setRjscSearchStatus(REQUEST_STATUS.ERROR))
        return dispatch(setRjscSearchError("search failed"))
    }
}

export const fetchOperatingBusinessData = (searchString) => async (dispatch, getState) => { 
    dispatch(setRjscAdvanceSearchStart())

    return fetch( RJSC_SERVICE_URL + `?registryId=${searchString}`, {
            method: "GET"
            // headers : headers
        })
        .then(resp => resp.json())
        .then((data) => {
            dispatch(setRjscSearchStatus(REQUEST_STATUS.DATA_RECEIVED))
            dispatch(setRjscAdvanceSearchResponse(data))
            return data
        })
        .catch((error) => {
            if(SHOW_DUMMY_RESPONSE) {
                dispatch(setRjscSearchStatus("dummy-data-received"))
                return dispatch(setRjscAdvanceSearchResponse(dummyRjscSearchResponse()))
            } else { 
                dispatch(setRjscSearchStatus(REQUEST_STATUS.ERROR))
                return dispatch(setRjscSearchError("search failed"))
            }
        })
        
}

/*
 * Below is a thunk. It will be called by the redux-thunk to generate async requests.
 * Make sure to return the dispatcher after success or failure to handle it in the UI
 */ 
export const fetchRjscDetails = (searchString) => async (dispatch, getState) => {
    dispatch(setRjscSearchStart())
    let searchType = getState().components.rjscSearch.searchType
    let fetchParam = ''
    if(searchType === "rjscSearchNumber") {
        fetchParam = "?registryId=" + searchString
    } else { 
        fetchParam = "?name=" + searchString
    }
    return fetch( RJSC_SERVICE_URL + fetchParam, {
            method: "GET"
            // headers : headers
        })
        .then(resp => resp.json())
        .then((data) => {
            dispatch(setRjscSearchStatus(REQUEST_STATUS.DATA_RECEIVED))
            dispatch(setRjscSearchResponse(data))
            return data
        })
        .catch((error) => {
            if(SHOW_DUMMY_RESPONSE) {
                dispatch(setRjscSearchStatus("dummy-data-received"))
                return dispatch(setRjscSearchResponse(dummyRjscSearchResponse()))
            } else { 
                dispatch(setRjscSearchStatus(REQUEST_STATUS.ERROR))
                return dispatch(setRjscSearchError("search failed"))
            }
        })
}

export default rjscSearchSlice.reducer
